import 'css-chunksrc/client/scenes/optimizedGantt/header/styles.scss';export default {
  "header": "_header_1pk8j_1",
  "firstLine": "_firstLine_1pk8j_13",
  "secondLine": "_secondLine_1pk8j_23",
  "selectors": "_selectors_1pk8j_35",
  "filters": "_filters_1pk8j_45",
  "creationMenu": "_creationMenu_1pk8j_52"
};